GP.GPMod('Unlock', function(self) {
    var _vent = null;
    var _log  = null;

    var _data = {
        // check and initialize a few params
        init: function() {
            _vent = self.vent;
            _log  = self.app.Util.log;
        },

        modal_input: {},
        override_confirm: false,

        // optional callback function to call on success of unlocking/purchase
        cb_func: null,
    };

    var gui = {
        init: function() {

        }
    };

    var apis = {
        purchase_unlock_msg_thread: function(product) {
            if (purchase_lock == false) {
                purchase_lock = true;

                self.api.json('msg.unlock_thread', {
                    data: {
                        duid: _data.modal_input.duid,
                        product: product
                    }
                }).done(function(json) {
                    _log('Unlock purchase_unlock_msg_thread json: ', json);

                    if (json.success) {
                        handlers.unlock_msg_thread_success(json);
                    } else {
                        // purchase failed, show an error
                        var error = (json.hasOwnProperty('error')) ? json.error : 'purchase failed';
                        alert(error);
                    }
                });
            }
        },
        purchase_unlock_explicit_content: function() {
            if (purchase_lock == false) {
                purchase_lock = true;
                self.api.json('user.unlock_explicit', {
                    data: {
                        duid: _data.modal_input.duid,
                        unlock: _data.modal_input.unlock
                    }
                }).done(function(json) {
                    _log('Unlock purchase_unlock_explicit json: ', json);

                    if (json.success) {
                        handlers.unlock_explicit_content_success(json);
                    } else {
                        // purchase failed, show an error
                        var error = (json.hasOwnProperty('error')) ? json.error : 'purchase failed';
                        alert(error);
                    }
                }).always(function() {});
            }
        },
        purchase_unlock_premium_filter: function() {
            if (purchase_lock == false) {
                purchase_lock = true;

                self.api.json('user.unlock_explicit', {
                    data: {
                        unlock: 'premium_filter',
                        filter_search: _data.modal_input.filter_search,
                        filter_inbox: _data.modal_input.filter_inbox
                    }
                }).done(function(json) {
                    _log('Unlock purchase_unlock_explicit json: ', json);

                    if (json.success) {
                        handlers.unlock_premium_filter_success(json);
                    } else {
                        // purchase failed, show an error
                        var error = (json.hasOwnProperty('error')) ? json.error : 'purchase failed';
                        alert(error);
                    }
                }).always(function() {});
            }
        },
        purchase_unlock_friend_request: function() {
            if (purchase_lock == false) {
                purchase_lock = true;

                self.api.json('user.unlock_friend_request', {
                    data: {
                        duid: _data.modal_input.duid
                    }
                }).done(function(json) {
                    _log('Unlock purchase_unlock_friend_request json: ', json);

                    if (json.success) {
                        handlers.unlock_friend_request_success(json);
                    } else {
                        // purchase failed, show an error
                        var error = (json.hasOwnProperty('error')) ? json.error : 'purchase failed';
                        alert(error);
                    }
                });
            }
        },
    };

    var handlers = {
        unlock_msg_thread_success: function() {
            // console.warn('unlock_msg_thread_success called, _data.modal_input: ', _data.modal_input);

            // show message before opening thread?
            var thread_json = $.extend(true, {}, _data.modal_input.thread_json);

            // console.log('unlock success! thread: ', thread_json);

            _vent.trigger('Modal:close');
            _vent.trigger('MessagePane.Inbox:load_thread_external', thread_json);
        },
        unlock_premium_filter_success: function() {
            _vent.trigger('Modal:close');
            window.location.href = window.location.href;
        },
        unlock_explicit_content_success: function() {
            _vent.trigger('Modal:close');

            if (_data.modal_input.content_id) {
                events.show_content_viewer();
            } else {
                // so the profile content can be visible now; refresh with rpec param
                // so that it skips cache
                var url = window.location.href;
                if (url.indexOf('?') > -1){
                    url += '&rpec=1';
                }else{
                    url += '?rpec=1';
                }
                window.location.href = url;
            }
        },
        unlock_friend_request_success: function() {
            _vent.trigger('Modal:close');

            // if we have a callback function to call once success is called, call that and reset
            if (typeof _data.cb_func === 'function') {
                _data.cb_func();
                _data.cb_func = null;
                return;
            }

            _vent.trigger('profile:add_friend', _data.modal_input.duid);
        },
    };

    var events = {
        init: function() {
            _vent.on('init_js:user:profile', function() {
                $(document).on('click', '.js-unlock-content', function() {
                    events.show_unlock_modal($(this).data('duid'));
                });
            });

            _vent.on(self.moduleName+":setup_modal", events.setup_modal);
            _vent.on(self.moduleName+':show_unlock_modal', events.show_unlock_modal);
            _vent.on(self.moduleName+':show_friend_request_modal', events.show_friend_request_modal);
            _vent.on(self.moduleName+':setup_thread_modal', events.setup_thread_modal);
            _vent.on(self.moduleName+':setup_explicit_modal', events.setup_explicit_modal);
            _vent.on(self.moduleName+':setup_premium_toggle_modal', events.setup_premium_toggle_modal);
            _vent.on(self.moduleName+':setup_friend_request_modal', events.setup_friend_request_modal);
            _vent.on(self.moduleName+':need_credits_modal', events.need_credits_modal);

            _vent.on(self.moduleName+':more_swipes_add_credits', events.more_swipes_add_credits);
            _vent.on(self.moduleName+':more_alerts_add_credits', events.more_alerts_add_credits);
        },
        setup_modal: function(modal_input) {},
        check_credits: function (ctx, success_cb) {
            _vent.trigger('User:check_credits', ctx, function (json) {
                var new_credits = parseInt(json.credits, 10);
                if (new_credits > 0) {
                    _vent.trigger('User:mod_user_credits', json, success_cb, ctx);
                }
            });
        },
        show_unlock_modal: function(duid, params = {}) {
            let modal_data = {
                url: '/members/billing/unlock_modal/',
                duid: duid,
                price: 3,
            };

            // option to show only the unlock button instead of unlock all button
            if (params.unlock_single === 'Y') {
                modal_data.unlock_single = params.unlock_single;
                modal_data.content_id = params.content_id;
                _data.clicked_model = params.clicked_model;
            }

            _vent.trigger('Modal:open', modal_data);
        },
        show_friend_request_modal: function(duid, cb) {
            // store ref to callback function to trigger on success if supplied
            if (typeof cb === 'function') {
                _data.cb_func = cb;
            }

            // Modal.js module will call `events.setup_friend_request_modal` via class attr in modal_shown callback
            _vent.trigger('Modal:open', {
                url: '/members/billing/unlock_modal/',
                duid: duid,
                price: 1,
                template: 'friend_request',
            });
        },
        setup_thread_modal: function(modal_input) {
            _data.override_confirm = false;
            _data.modal_input = modal_input;

            // console.log('Unlock.setup_thread_modal called with modal_input: ', modal_input);

            // setup click handler for unlock button and either spend the credits
            // to unlock if we have them, or redirect to credit purchase page
            // $(document).on('click', '.btn-unlock-thread', function(e) {
            $('.modal .btn-unlock-thread').on('click', function(e) {
                // REFUNDABLE
                e.preventDefault();
                var price = $(this).data('price');
                var product = $(this).data('product');
                events.unlock_msg_thread(price, product);
            });
            $('.modal .btn-unlock-thread-no-refund').on('click', function(e) {
                // NON-REFUNDABLE
                e.preventDefault();
                var price = $(this).data('price');
                var product = $(this).data('product');
                events.unlock_msg_thread(price, product);
            });
        },
        setup_explicit_modal: function(modal_input) {
            _data.override_confirm = false;
            _data.modal_input = modal_input;

            // setup click handler for unlock button and either spend the credits
            // to unlock if we have them, or redirect to credit purchase page
            // $(document).on('click', '.btn-unlock-explicit', function(e) {
            $('.modal .btn-unlock-explicit').on('click', function(e) {
                e.preventDefault();
                _data.modal_input.unlock = $('input[name="unlock_option"]:checked').val();
                _data.modal_input.global_price = $('input[name="global_price"]').val();
                events.unlock_explicit_content();
            });
        },
        setup_premium_toggle_modal: function(modal_input) {
            _data.override_confirm = false;
            _data.modal_input = modal_input;

            // setup click handler for unlock button and either spend the credits
            // to unlock if we have them, or redirect to credit purchase page
            // $(document).on('click', '.btn-unlock-explicit', function(e) {
            $('.modal .btn-unlock-premium-toggle').on('click', function(e) {
                e.preventDefault();
                _data.modal_input.filter_search = $('input[name="premium_filter_search"]:checked').val();
                _data.modal_input.filter_inbox = $('input[name="premium_filter_inbox"]:checked').val();
                events.unlock_premium_filter();
            });
        },
        setup_friend_request_modal: function(modal_input) {
            _data.modal_input = modal_input;

            // setup click handler for unlock button and either spend the credits
            // to send friend request if we have them,
            // or show modal to purchase credits (or redirect if no billing)
            // $(document).on('click', '.btn-unlock-friend-request', function(e) {
            $('.modal .btn-unlock-friend-request').on('click', function(e) {
                e.preventDefault();
                events.unlock_friend_request();
            });
        },
        unlock_friend_request: function() {
            var _this = this,
                price = _data.modal_input.price;
                purchase_lock = false;
            // check credits vs price and spend credits if user has enough
            if (!_oc && GP.sdata.my_user.credits >= price) {

                apis.purchase_unlock_friend_request();
            } else {

                // bind to custom event that the iframe success template will trigger
                $('body').one('fl_credits_purchased', function(e) {
                    _oc = false;

                    // give the PB some time to update the DB and fire
                    // the mod_user_credits cometd message
                    // which should update the user's shared data (sdata)
                    setTimeout(function() {
                        if (GP.sdata.my_user.credits >= price) {
                            _vent.trigger('Modal:close');
                            apis.purchase_unlock_friend_request();
                        } else {
                            events.check_credits(_this, events.unlock_friend_request);
                        }
                    }, 2000);
                });

                // trigger modal to purchase credits if one click is available, or redirect to billing
                if (GP.sdata.my_user.can_oneclick) {
                    _vent.trigger('Modal:open', {
                        url: "/members/billing/credit_modal/",
                    });
                } else {
                    window.location.href = GP.Util.clean_url('/members/billing/add_credits/?unlock=friend_request&pduid='+_data.modal_input.duid);
                }

            }
        },
        unlock_msg_thread: function(price, product) {
            var _this = this;
            if (!price) {
                price = _data.modal_input.price;
            }
            purchase_lock = false;
            // check credits vs price and spend credits if user has enough
            if (!_oc && GP.sdata.my_user.credits >= price) {
                apis.purchase_unlock_msg_thread(product);
            } else {
                // bind to custom event that the iframe success template will trigger
                $('body').one('fl_credits_purchased', function(e) {
                    _oc = false;

                    // give the PB some time to update the DB and fire
                    // the mod_user_credits cometd message
                    // which should update the user's shared data (sdata)
                    setTimeout(function() {
                        if (GP.sdata.my_user.credits >= price) {
                            _vent.trigger('Modal:close');
                            apis.purchase_unlock_msg_thread();
                        } else {
                            events.check_credits(_this, events.unlock_msg_thread(price, product));
                        }
                    }, 2000);
                });

                // trigger modal to purchase credits if one click is available, or redirect to billing
                if (GP.sdata.my_user.can_oneclick) {
                    _vent.trigger('Modal:open', {
                        url: "/members/billing/credit_modal/",
                    });
                } else {
                    window.location.href = GP.Util.clean_url('/members/billing/add_credits/?unlock=msg_thread&pduid='+_data.modal_input.duid);
                }

            }
        },
        unlock_explicit_content: function() {
            var _this = this,
                price = _data.modal_input.price;
                purchase_lock = false;
                // if a/b test price is different
                if (_data.modal_input.unlock == 'global') {
                    price = _data.modal_input.global_price;
                }

            // check credits
            if (!_oc && GP.sdata.my_user.credits >= price) {
                apis.purchase_unlock_explicit_content();
            } else {

                // bind to custom event that the iframe success template will trigger
                $('body').one('fl_credits_purchased', function(e) {
                    _oc = false;

                    // give the PB some time to update the DB and fire
                    // the mod_user_credits cometd message
                    // which should update the user's shared data (sdata)
                    setTimeout(function() {
                        if (GP.sdata.my_user.credits >= price) {
                            _vent.trigger('Modal:close');
                            apis.purchase_unlock_explicit_content();
                        } else {
                            events.check_credits(_this, events.unlock_explicit_content);
                        }
                    }, 2000);
                });

                // trigger modal to purchase credits if one click is available, or redirect to billing
                if (GP.sdata.my_user.can_oneclick) {
                    _vent.trigger('Modal:open', {
                        url: "/members/billing/credit_modal/",
                    });
                } else {
                    window.location.href = GP.Util.clean_url('/members/billing/add_credits/?unlock=ex_content&pduid='+_data.modal_input.duid);
                }
            }
        },
        unlock_premium_filter: function() {
            var _this = this,
                price = '5';
                purchase_lock = false;

            // check credits
            if (!_oc && GP.sdata.my_user.credits >= price) {
                apis.purchase_unlock_premium_filter();
            } else {

                // bind to custom event that the iframe success template will trigger
                $('body').one('fl_credits_purchased', function(e) {
                    _oc = false;

                    // give the PB some time to update the DB and fire
                    // the mod_user_credits cometd message
                    // which should update the user's shared data (sdata)
                    setTimeout(function() {
                        if (GP.sdata.my_user.credits >= price) {
                            _vent.trigger('Modal:close');
                            apis.purchase_unlock_premium_filter();
                        } else {
                            events.check_credits(_this, events.unlock_explicit_content);
                        }
                    }, 2000);
                });

                // trigger modal to purchase credits if one click is available, or redirect to billing
                if (GP.sdata.my_user.can_oneclick) {
                    _vent.trigger('Modal:open', {
                        url: "/members/billing/credit_modal/",
                    });
                } else {
                    window.location.href = GP.Util.clean_url('/members/billing/add_credits/?unlock=ex_content&pduid='+_data.modal_input.duid);
                }
            }
        },
        need_credits_modal: function() {
            vent.trigger('Modal:open:confirm', { template: 'NEED_CREDITS' }, function() {
                window.location.href = GP.Util.clean_url('/members/billing/add_credits/');
             });
        },
        show_content_viewer: function() {
            GP.vent.trigger('Modal:open', {
                url: GP.Util.clean_url('/members/content/viewer/', {
                    duid: _data.modal_input.duid,
                    content_id: _data.modal_input.content_id,
                }),
            }, {},
            function() {
                events.update_clicked_content();
            });
        },
        // updates blurred thumb preview with unblurred pic after purchase success
        update_clicked_content: function() {

            if (viewer_content.type === 'IMAGE') {
                _data.clicked_model.set('url', viewer_content.url);
            } else if (viewer_content.type === 'VIDEO') {
                _data.clicked_model.set('video_thumb_url', viewer_content.video_thumb_url);
            }
            _data.clicked_model.set('pic', viewer_content.top_score_pic);
            _data.clicked_model.set('blurred', false);
        },
        more_swipes_add_credits: function(input) {
            let _this = this;
            let price = input.price;

            // bind to custom event that the iframe success template will trigger
            $('body').one('fl_credits_purchased', function(e) {
                _oc = false;

                // give the PB some time to update the DB and fire
                // the mod_user_credits cometd message
                // which should update the user's shared data (sdata)
                setTimeout(function() {
                    if (GP.sdata.my_user.credits >= price) {
                        GP.vent.trigger('Modal:close');

                        // reload match game page so purchased swipes are counted
                        window.location.reload();
                    } else {
                        events.check_credits(_this, window.location.reload());
                    }
                }, 2000);
            });

            if (!_oc && GP.sdata.my_user.can_oneclick) {
                GP.vent.trigger('Modal:open', {url: '/members/billing/credit_modal/', backdrop: 'static'});
            } else {
                window.location.href = GP.Util.clean_url('/members/billing/add_credits/');
            }
        },
        more_alerts_add_credits: function(input) {
            let _this = this;
            let price = input.price;

            // bind to custom event that the iframe success template will trigger
            $('body').one('fl_credits_purchased', function(e) {
                _oc = false;

                // give the PB some time to update the DB and fire
                // the mod_user_credits cometd message
                // which should update the user's shared data (sdata)
                setTimeout(function() {
                    if (GP.sdata.my_user.credits >= price) {
                        GP.vent.trigger('Modal:close');

                        // reload match game page so purchased swipes are counted
                        window.location.reload();
                    } else {
                        events.check_credits(_this, window.location.reload());
                    }
                }, 2000);
            });

            if (!_oc && GP.sdata.my_user.can_oneclick && GP.sdata.my_user.membership != 'FREE') {
                GP.vent.trigger('Modal:open', {url: '/members/billing/credit_modal/', backdrop: 'static'});
            } else {
                window.location.href = GP.Util.clean_url('/members/billing/add_credits/');
            }
        }
    };

    this.addInitializer(function(){
        _data.init();
        events.init();
        gui.init();
    });
});
